import { render, staticRenderFns } from "./AppBackdrop.vue?vue&type=template&id=852afc2a&scoped=true&"
import script from "./AppBackdrop.vue?vue&type=script&lang=js&"
export * from "./AppBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./AppBackdrop.vue?vue&type=style&index=0&id=852afc2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852afc2a",
  null
  
)

export default component.exports